export enum DetailSidebarItems {
    TS = 1,
    IS = 2,
    DS = 3,
    F33 = 4,
    F11 = 5,
    HV_POLE = 6,
    MV_POLE = 7,
    LV_POLE = 8,
    DEVICES = 9,
    BUILDINGS = 10,
    METERS = 11
}